export const EquationRelationTo = () =>{
    return(
        <div className="container">
            <p>数式エディタの<a href="/tcgcreatoreternalbetaver2/card_variable">カード変数</a>で指定されたもののうち紐づけされたものをカウントする場合紐づけをしているかされているかを示しま</p>
            <img src={`${process.env.PUBLIC_URL}/equation_relation_to.png`}></img>
            <p>図の例で紐づけがを受けていることを表しています</p>
            </div>
    )
}
